// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3RUNp","content":"ManualTimeModal_content__A5ipp"};